import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
    Container,
    Grid,
    Typography,
    TextField,
    CircularProgress,
    Paper,
    Select,
    MenuItem,
} from "@material-ui/core";
import { BUSCADOR_CENTRAL, OBRAS_SOCIALES, STEPPER_AUTORIZACIONES } from "../../../../utils/constants";
import { cleanAfiliadoSeleccionado, setActiveStep, setAfiliadoSeleccionado } from "../../../../actions/certificadoAtencion/certificadoAtencionActions";
import { getObrasSociales } from "../../../../actions/afiliado";
import { fetchConToken } from "../../../../helpers/fetch";
import { startAlerta } from "../../../../actions/ui/alertas";

export const CertificadoAtencionAfiliadoBuscador = (props) => {

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    const { obrasSociales = [] } = useSelector((state) => state.obrasSociales);

    const cargando = open && options.length === 0;
    const [textoBuscado, setTextoBuscado] = useState("");
    const { tipoBusqueda = "Todos", altaBaja = "Alta", idObraSocial, setIdObraSocial, onModal } = props;
    const dispatch = useDispatch();

    const marginTopValue = onModal ? -25 : 5;


    const handleInputChange = (e) => {
        let typingTimer = null;

        if (idObraSocial === OBRAS_SOCIALES.OSPEDYC) {
            if (e.target.value.length >= BUSCADOR_CENTRAL.CARACTERES_MINIMOS_AFILIACIONES) {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(() => {
                    setTextoBuscado(e.target.value);
                }, BUSCADOR_CENTRAL.MILISEG_SIN_CAMBIOS);
            } else {
                limpiarComponente();
            }
        } else {
            let value = e.target.value.replace(/[^0-9]/g, '');
            if (value.length >= BUSCADOR_CENTRAL.CARACTERES_MINIMOS_TURNOS_EXTERNOS) {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(() => {
                    setTextoBuscado(value);
                }, BUSCADOR_CENTRAL.MILISEG_SIN_CAMBIOS_EXT);
            } else {
                limpiarComponente();
            }
        }
    };

    const handleAfiliadoSeleccionado = (afiliado) => {
        if (!!afiliado) {
            if (idObraSocial === OBRAS_SOCIALES.OSPEDYC) {
                dispatch(setAfiliadoSeleccionado(afiliado));
                dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DATOS_TITULAR));
            } else {
                dispatch(setAfiliadoSeleccionado(afiliado));
                dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DATOS_TITULAR));
            }
        } else {
            limpiarComponente();
        }
    };

    useEffect(() => {
        if (obrasSociales.length === 0)
            dispatch(getObrasSociales());
        setIdObraSocial(idObraSocial !== null ? idObraSocial : OBRAS_SOCIALES.OSPEDYC);
    }, [dispatch]);

    useEffect(() => {
        let active = true;
        (async () => {
            let texto = textoBuscado.replace("/", "__");
            if (texto.length > 0) {
                if (idObraSocial === OBRAS_SOCIALES.OSPEDYC) {
                    const response = await fetchConToken(
                        `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                    );
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        const lista = await response.json();
                        if (active && lista.length > 0) {
                            setOptions(
                                Object.keys(lista).map((id_afiliado) => lista[id_afiliado])
                            );
                        }
                    }
                } else {
                    const response = await fetchConToken(
                        `AfiliadosExternos/validarAfiliadoExterno/${idObraSocial}/${texto}`
                    );
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {

                        const lista = await response.json();

                        if (active && lista.length > 0) {
                            setOptions(
                                Object.keys(lista).map((id_afiliado) => lista[id_afiliado])
                            );
                        }
                        if (lista.errores && lista.errores !== "" && texto.length === 8) {
                            dispatch(startAlerta("Afiliado inexistente o dado de baja.", "error"))
                        }
                    }

                    /*
                    const obraSocial = obrasSociales.find(s => s.idObraSocial === idObraSocial);
          
                    const response = await fetchSinTokenExterno(
                      obraSocial.url, //`http://m1m.ddns.net/api/api`
                      obraSocial.endPoint+`${texto}`//`PadronDapper/Afiliado/BuscadorParaOspe?parametros=${texto}`
                    );
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                      const lista = await response.json();
                      if (active && lista.length > 0) {
                        setOptions(
                          Object.keys(lista).map((id_afiliado) => lista[id_afiliado])
                        );
                      }
                    }
                    */
                }

            }
        })();
        return () => {
            active = false;
        };
        // eslint-disable-next-line
    }, [textoBuscado]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const limpiarComponente = () => {
        dispatch(cleanAfiliadoSeleccionado());
    };

    return (
        <>

            <Grid container spacing={2}>
                {!props.hideTitle &&
                    <Grid item xs={3}>
                        <Typography
                            component="h1"
                            variant="h5"
                            style={{
                                marginLeft: 25,
                                marginTop: 20,
                                align: "center",
                                color: "#FAFAFA",
                                justifyContent: "center",
                            }}
                        >
                            Obra Social
                        </Typography>
                    </Grid>
                }
                <Grid item xs={!props.hideTitle ? 8 : 12}>
                    <Container
                        style={{
                            padding: 3,
                            marginTop: 15,
                            margin: 5,
                        }}
                    >
                        <Paper style={{ padding: 10 }}>
                            {Array.isArray(obrasSociales) && obrasSociales.length > 0 && (
                                <Select
                                    fullWidth
                                    margin="normal"
                                    label="OS"
                                    name="idObraSocial"
                                    value={idObraSocial}
                                    onChange={(e) => {
                                        setIdObraSocial(e.target.value);
                                        handleAfiliadoSeleccionado(null);
                                        setTextoBuscado("");
                                    }}
                                    style={{
                                        // width: !props.hideTitle && 500,
                                        padding: 6,
                                        backgroundColor: "#FAFAFA",
                                        borderRadius: "5px",
                                    }}
                                >
                                    {obrasSociales.map((ObraSocial) => (
                                        <MenuItem
                                            key={ObraSocial.idObraSocial}
                                            value={ObraSocial.idObraSocial}
                                        >
                                            {ObraSocial.siglas} - {ObraSocial.razonSocial}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        </Paper>
                    </Container>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                {!props.hideTitle &&
                    <Grid item xs={3}>
                        <Typography
                            component="h1"
                            variant="h5"
                            style={{
                                marginLeft: 25,
                                marginTop: 20,
                                align: "center",
                                color: "#FAFAFA",
                                justifyContent: "center",
                            }}
                        >
                            Buscar
                        </Typography>
                    </Grid>
                }
                <Grid item xs={!props.hideTitle ? 8 : 12}>
                    <Container
                        style={{
                            padding: 3,
                            marginTop: marginTopValue,
                            margin: 5,
                        }}
                    >
                        <Autocomplete
                            id="buscadorAfiliados"
                            fullWidth={!props.hideTitle}
                            style={{
                                // width: !props.hideTitle ? 500 : undefined,
                                padding: 6,
                                backgroundColor: "#FAFAFA",
                                borderRadius: "5px",
                            }}
                            loadingText="Buscando..."
                            open={open}
                            onOpen={() => {
                                setOpen(true);
                            }}
                            onClose={() => {
                                setOpen(false);
                            }}
                            onChange={(event, newValue) => {
                                handleAfiliadoSeleccionado(newValue);
                            }}
                            getOptionSelected={(option, value) =>
                                option.id_afiliado === value.id_afiliado
                            }
                            getOptionLabel={(option) =>
                                idObraSocial === OBRAS_SOCIALES.OSPEDYC
                                    ? `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                                    : `${option.apellido_y_nombre} ${option.nro_doc}`
                            }
                            renderOption={(option) => (
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <span
                                        style={
                                            option.fecha_baja === null
                                                ? { color: "green" }
                                                : { color: "red" }
                                        }
                                    >
                                        {`${option.apellido_y_nombre}`}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: 12,
                                        }}
                                    >
                                        {" "}
                                        {idObraSocial === OBRAS_SOCIALES.OSPEDYC
                                            ? `Nro Afi:${option.carnet} - CUIL:${option.cuil}`
                                            : `DNI:${option.nro_doc}`}
                                    </span>
                                </div>
                            )}
                            options={options}
                            loading={cargando}
                            noOptionsText="No se encontraron resultados"
                            renderInput={(params) => (
                                <TextField
                                    onChange={handleInputChange}
                                    style={{
                                        padding: 3,
                                    }}
                                    {...params}
                                    label={
                                        idObraSocial === OBRAS_SOCIALES.OSPEDYC
                                            ? "Apellido y Nombre | Nro Doc | Nro Afiliado | CUIL"
                                            : "Nro de Documento"
                                    }
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {cargando ? (
                                                    <CircularProgress color="inherit" size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                    type="text"
                                />
                            )}
                        />
                    </Container>
                </Grid>
            </Grid>
        </>
    );
};
